/**
 * Converts a spacing object to Tailwind CSS classes
 * @param {Object} spacing - The spacing object with top, right, bottom, left properties
 * @param {string} type - Either "margin" or "padding"
 * @returns {string} - Space-separated Tailwind CSS classes
 */

function setAuto(spacing, auto) {
  if (typeof auto !== "number") {
    return spacing;
  }
  if (spacing && typeof spacing === "object") {
    const sides = ["top", "right", "bottom", "left"];
    for (const side of sides) {
      if (spacing[side] === "auto") {
        spacing[side] = auto;
      }
    }
  }
  return spacing;
}

export function getSpacingClass(spacing, type, ignore, auto) {
  spacing = setAuto(spacing, auto);
  if (!spacing || typeof spacing !== "object" || ignore) {
    return type === "margin" ? "m-0" : "p-0";
  }

  const classes = [];
  const prefix = type === "margin" ? "m" : "p";
  const sides = ["top", "right", "bottom", "left"];

  for (const side of sides) {
    const value = spacing[side];
    if (value !== undefined && value !== null && value !== "auto") {
      classes.push(`${prefix}${side.charAt(0)}-${value}`);
    }
  }

  return classes.length > 0
    ? classes.join(" ")
    : type === "margin"
      ? "m-auto"
      : "p-0";
}
